<span class="inbound-title">
  <span class="mat-headline-6 activity-card-title">Inbound calling activity (by number)</span>
</span>
<onsip-loading-container [deferCond]="loadingStateComplete$">
  @if (inboundData.length > 0) {
  <div class="graphics-container">
    <div class="donut-graph-container">
      <onsip-donut-graph [data]="phoneNumberData"></onsip-donut-graph>
    </div>
    <div class="bar-graph-container">
      <onsip-highcharts-bar-graph
        [data]="inboundData"
        [graphWidth]="barGraphWidth"
      ></onsip-highcharts-bar-graph>
    </div>
  </div>
  } @else {
  <div class="empty-state">
    <img
      class="empty-state-img"
      [src]="'resources/img/Inbound-outbound-activity-emptystate.svg'"
      alt="inbound-outbound-empty-state"
    />
    <span class="mat-body-1">there is no inbound calling activity yet</span>
  </div>
  }
</onsip-loading-container>
